import module0 from '@ice/plugin-request/runtime';
                import module1 from '@ali/ice-plugin-spm/runtime';
                
export const statics = [
  module0,
];
export const commons = [
  module1,
];
